import { RichTextEditorStylesNames } from '@mantine/tiptap';
import useTheme from './useTheme';

/**
 * This component will show a text input styling when the collapsed value is false
 * It will show the expanded richtTexteditor when the value is true
 * @param isCollapsed
 */
const useRichTextAnimatedFocusStyling = (
  isCollapsed: boolean,
): Partial<Record<RichTextEditorStylesNames, string | object>> => {
  const { space } = useTheme();
  return {
    root: {
      '.ql-blank::before': !isCollapsed
        ? {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }
        : {},
      p: {
        marginBottom: isCollapsed ? undefined : 0,
        transition: '0.2s',
      },
    },
    content: {
      minHeight: 'unset',
      height: isCollapsed ? 'unset' : `calc(${space[12]} + 0px)`,
      maxHeight: isCollapsed ? space[28] : `calc(${space[12]} + 0px)`,
      padding: isCollapsed ? undefined : space[2],
      paddingBottom: isCollapsed ? undefined : 0,
      transition: '0.2s',
      '>div': {
        height: isCollapsed ? 'auto' : '0',
        padding: isCollapsed ? undefined : '0 !important',
        transition: '0.2s',
      },
    },
    toolbar: {
      ...(!isCollapsed && {
        height: 0,
        paddingTop: 0,
        paddingBottom: 0,
        borderWidth: '0',
      }),
      overflow: 'hidden',
      transition: '0.2s',
    },
  };
};

export default useRichTextAnimatedFocusStyling;
